module.exports = __webpack_public_path__ + "static/media/coming_soon.ac43a81d.jpeg";